import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/tipos-de-descuentos';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: true,
  });
  return [formattedValues, config];
};

/**
 * GET Tipos Descuentos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getTiposDescuentos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo Descuento
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getTipoDescuento = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo Descuento
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDescuento = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo Descuento
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDescuento = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo Descuento
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteTipoDescuento = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
